module.exports = __webpack_public_path__ + "static/media/7304.631af7c2.JPG";